import {
  StorageMountsAdminPage as PlatformStorageMountsAdminPage,
  type StorageMountsAdminApi,
  type StorageMountsAdminCopy
} from '@jarvis/platform-ui';
import {
  createMount,
  deleteMount,
  getMount,
  listMounts,
  listRoles,
  searchGroups,
  testMount,
  testMountConnection,
  updateMount
} from '../../../api/storageMountsAdmin';

const storageMountsApi: StorageMountsAdminApi = {
  listMounts,
  getMount,
  createMount,
  updateMount,
  deleteMount,
  testMount,
  testMountConnection,
  listRoles,
  searchGroups
};

const assistantCopy: StorageMountsAdminCopy = {
  apiSiteLabel: 'JARVIS IT Assistant',
  pageSubtitle:
    'Configure SMB shares and S3/MinIO buckets for the Assistant file browser. Assign Assistant roles and Entra group bindings to control per-mount visibility.',
  noBindingsHint: 'No bindings — only AssistantSysAdmin and global override groups can access this mount.',
  accessGrantHint:
    'Grant an Assistant role (+ optional Entra group) read or write access. AssistantSysAdmin always has full access to all mounts.',
  adminRoleLabel: 'AssistantSysAdmin'
};

export function StorageMountsAdminPage() {
  return (
    <PlatformStorageMountsAdminPage
      api={storageMountsApi}
      copy={assistantCopy}
      stateStorageKey="assistantui:storage-mounts-grid"
    />
  );
}
